// Translated labels for Resurs financing statuses, shared by the dialog, panel and badge.
export const OPEN_STATUSES = ['created', 'pending'];

export const resursStatusLabel = (t, status) => {
  switch (status) {
    case 'created':
      return t('resurs.statusCreated');
    case 'pending':
      return t('resurs.statusPending');
    case 'paid':
      return t('resurs.statusPaid');
    case 'denied':
      return t('resurs.statusDenied');
    case 'cancelled':
      return t('resurs.statusCancelled');
    case 'expired':
      return t('resurs.statusExpired');
    case 'error':
      return t('resurs.statusError');
    case 'refunded':
      return t('resurs.statusRefunded');
    default:
      return status;
  }
};

export const resursResultText = (t, status) => {
  switch (status) {
    case 'paid':
      return t('resurs.resultPaid');
    case 'denied':
      return t('resurs.resultDenied');
    case 'cancelled':
      return t('resurs.resultCancelled');
    case 'expired':
      return t('resurs.resultExpired');
    default:
      return t('resurs.resultError');
  }
};

export const formatTime = (iso) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit' });
  } catch (e) {
    return '';
  }
};
